import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
//import { Product } from '../checkout/checkout.model';
import { Observable, of as observableOf } from 'rxjs';
import { map} from "rxjs/operators";
import { catchError } from 'rxjs/operators';
import { FileUploadModule } from 'ng2-file-upload';



@Injectable({
  providedIn: 'root'
})
export class UserService {
  user_id = '';
  constructor(private httpClient: HttpClient) { }

  api_url = 'https://nuflorist.com/nfsadmin/api';
  profile_image_url = 'https://nuflorist.com/nfsadmin/public/users/';
  product_image_url = 'https://nuflorist.com/nfsadmin/public/images/products-images/';
  
  //api_url = 'http://localhost/nfsadmin/api';
  //profile_image_url = 'http://localhost/nfsadmin/public/users/';
  //product_image_url = 'http://localhost/nfsadmin/public/images/products-images/';

  // Login API // 

  loginRequest(email, password, token) {
    return this.httpClient.post<any>(this.api_url + '/login', { email, password, token });
  }

  passwordReset(password, confirmPassword) {
    if(localStorage.getItem('user_id') !== null){
    var user_id = localStorage.getItem('user_id');

  }
    return this.httpClient.post<any>(this.api_url + '/passwordReset', { password, confirmPassword,user_id });
  }

  forgotPassword(email) {
    return this.httpClient.post<any>(this.api_url + '/forgotpassword', { email });
  }

  signupRequest(email, password,first_name,last_name) {
    return this.httpClient.post<any>(this.api_url + '/register', { email, password,first_name,last_name });
  }

  getAllProducts() {
       var user_id = '';
    if(localStorage.getItem('nu_c_user_id') !== null){
       user_id =  localStorage.getItem('nu_c_user_id');
   }
    return this.httpClient.post<any>(this.api_url + '/getProductsList', { user_id});
  }


  getcountries() {
    return this.httpClient.post<any>(this.api_url + '/getCountries', {});
  }
  
  getYearList() {
    return this.httpClient.post<any>(this.api_url + '/getYearList', {});
  }

  getRegions(country_id) {
    return this.httpClient.post<any>(this.api_url + '/getRegions', { country_id });
  }

  getCities(country_id, region_id) {
    return this.httpClient.post<any>(this.api_url + '/getCities', { country_id, region_id })
  }

  GetProductbyId(product_id) {
    return this.httpClient.post<any>(this.api_url + '/getProductInfo', { product_id })
  }

  GetUserDetails(user_id) {
    return this.httpClient.post<any>(this.api_url + '/getUserDetails', { user_id })
  }


  custmoreRegister(email, password, mobile_no, first_name, address_line1, city, country, state, zip, needValidation) {

    let filterProducts = JSON.parse(localStorage.getItem("FilterProduct"));

    if(localStorage.getItem('nu_c_user_id') !== null){
       var user_id =  localStorage.getItem('nu_c_user_id');
    }
    
    return this.httpClient.post<any>(this.api_url + '/customerRegister', { email, password, mobile_no, first_name, address_line1, city, country, state, zip, needValidation, filterProducts,user_id });
  }

  custmoreRegisterFinal(customre, StripeToken, Card_id, Total_price, packageDetail, save_card='') {

    if(localStorage.getItem('nu_c_user_id') !== null){
      var user_id =  localStorage.getItem('nu_c_user_id');
   } 
    let filterProducts = JSON.parse(localStorage.getItem("FilterProduct"));

    let TotalAmount = JSON.parse(localStorage.getItem('OverallTotal'))

    let AllData = {
      "customre":customre,
      "StripeToken":StripeToken,
      "Card_id":Card_id,
      "filterProducts":packageDetail,
      "TotalAmount":Total_price,
      "user_id":user_id,
      "save_card":save_card,
    }

    return this.httpClient.post<any>(this.api_url + '/customerRegisterFinal', { AllData });
  }


// api for get all product grouping data // 

  getUserPurchasedProducts(user_id){

    return this.httpClient.post<any>(this.api_url + '/getUserPurchasedProductsList', {user_id })
  } 
	
	getCreditTransactions(user_id){

    return this.httpClient.post<any>(this.api_url + '/getCreditTransactions', {user_id })
  } 


  getProductTransactions(user_id){

    return this.httpClient.post<any>(this.api_url + '/getProductTransactions', {user_id })
  }  
  
  getProductTransactionsBilling(user_id){

    return this.httpClient.post<any>(this.api_url + '/getProductTransactionsBilling', {user_id })
  }
  getProductTransactionsSingle(user_id,transaction_id){

    return this.httpClient.post<any>(this.api_url + '/getProductTransactionsSingle', {user_id, transaction_id })
  }
validateEmail(email){

  return this.httpClient.post<any>(this.api_url + '/validateEmail',{email})
}

changeUserPassword(oldPassword,newPassword,confirmPassword,user_id){
  return this.httpClient.post<any>(this.api_url + '/changeUserPassword',{oldPassword,newPassword,confirmPassword,user_id})
}

getCustomerCards(){

  var user_id =  localStorage.getItem('nu_c_user_id');  
  return this.httpClient.post<any>(this.api_url + '/getCustomerCards',{user_id})
}

CreateCompanyAndStores(companyData){
  var user_id =  localStorage.getItem('nu_c_user_id');
  // let storesData  = JSON.parse(companyData);  
  let CompanyData = {
    "CompanyData":companyData,
    "user_id":user_id
  }

  return this.httpClient.post<any>(this.api_url + '/addCompanyPlusStore',{ CompanyData})
}

getCompanyAndStores(){
  var user_id =  localStorage.getItem('nu_c_user_id');  

  return this.httpClient.post<any>(this.api_url + '/getUserCompaniesList',{ user_id})

}

deleteStore(company_id,store_id){
  var user_id =  localStorage.getItem('nu_c_user_id');  

  return this.httpClient.post<any>(this.api_url + '/deleteStore',{ user_id,company_id,store_id})  
}

getCompanyinfo(company_id){

  return this.httpClient.post<any>(this.api_url + '/getCompanyInfo',{ company_id})
}

updateCompanyPlusStore(companyData){
  var user_id =  localStorage.getItem('nu_c_user_id');
  let CompanyData = {
    "CompanyData":companyData,
    "user_id":user_id
  }

  return this.httpClient.post<any>(this.api_url + '/updateCompanyPlusStore',{CompanyData})

}

getAllottedLicensesList(transaction_id){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/getAllottedLicenses',{ transaction_id,user_id})
}

Cancellicenses(subscription_id){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/cancelSubscription',{ subscription_id,user_id})
}

updateCustomerInfo(mobile_no, first_name,last_name, address, address_optional, city, country, state, zip){
  var user_id =  localStorage.getItem('nu_c_user_id');

  return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {mobile_no, first_name,last_name, address, address_optional, city, country, state, zip,user_id });
  }

  updateCustomerMobile(mobile_no){
    var user_id =  localStorage.getItem('nu_c_user_id');
  
    return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {mobile_no,user_id });
  }

  updateCustomerEmail(email){
    var user_id =  localStorage.getItem('nu_c_user_id');
  
    return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {email,user_id });
  }

  updateCustomerName(first_name,last_name){
    var user_id =  localStorage.getItem('nu_c_user_id');
  
    return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {first_name,last_name,user_id });
  }

  updateCustomerAddress(address, city, state, zip, country){
    var user_id =  localStorage.getItem('nu_c_user_id');
  
    return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {address, city, state, zip, country, user_id });
  }

  getCustomerInvoices( user_id){
    // var user_id =  localStorage.getItem('nu_c_user_id');

    return this.httpClient.post<any>(this.api_url + '/getCustomerInvoices',{user_id })

  }

  updateCustomerCard(user_id ,stripe_token,card_id){
    return this.httpClient.post<any>(this.api_url + '/updateCustomerCard',{user_id ,stripe_token,card_id })

  } 
  

  addNewCompany(companyData){
    var user_id =  localStorage.getItem('nu_c_user_id');
  // let storesData  = JSON.parse(companyData);  
  let CompanyData = {
    "CompanyData":companyData,
    "user_id":user_id
  }

  return this.httpClient.post<any>(this.api_url + '/addNewCompany',{ CompanyData})
  }


  addNewStore(StoreData,company_id){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    var company_id = company_id;
    
  
    return this.httpClient.post<any>(this.api_url + '/addNewStore',{company_id,user_id,StoreData})


  }

  getUserCompanies(){
    var user_id =  localStorage.getItem('nu_c_user_id');
    return this.httpClient.post<any>(this.api_url + '/getUserCompanies',{user_id})
  }

  getUserStores(company_id){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));

    
    return this.httpClient.post<any>(this.api_url + '/getUserStores',{company_id,user_id})
  }

  getUserStoreList(){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));

    
    return this.httpClient.post<any>(this.api_url + '/getUserStoreList',{user_id})
  }

// api for allot-licences//

   UserPurchasedProducts(){
    var user_id =  localStorage.getItem('nu_c_user_id');
     var forLicenseAllot = 1
    return this.httpClient.post<any>(this.api_url + '/getUserPurchasedProducts',{user_id,forLicenseAllot}) 

   }

   createAdminUser(AdminData){
    var user_id =  localStorage.getItem('nu_c_user_id');
    return this.httpClient.post<any>(this.api_url + '/createAdminUser',{user_id,AdminData})
   }
   createSubAdmin(AdminData){
    var user_id =  localStorage.getItem('nu_c_user_id');
    return this.httpClient.post<any>(this.api_url + '/createSubAdmin',{user_id,AdminData})
   }

   getAdminUsers(){
    var user_id =  localStorage.getItem('nu_c_user_id');
    return this.httpClient.post<any>(this.api_url + '/getAdminUsers',{user_id})
   }
   get_user_permissions(user_id){
    return this.httpClient.post<any>(this.api_url + '/get_user_permissions',{user_id})
   }

   isEmailRegisterd(email: string) {    
return this.httpClient.post<any>(this.api_url + '/validateEmail',{email})     
}

checkPasswordToken( p_token){
// console.log(token);
  return this.httpClient.post<any>(this.api_url + '/checkPasswordToken',{ p_token})     
 
}

 
updateCustomerSubscription(subscriptionData){
  var user_id =  localStorage.getItem('nu_c_user_id');

  return this.httpClient.post<any>(this.api_url + '/updateCustomerSubscription',{user_id,subscriptionData})

}

updateSubscriptionAdmin(admin_user_id){
  var subscription_id = localStorage.getItem('subscription_id')
 

 return this.httpClient.post<any>(this.api_url +'/updateSubscriptionAdmin',{subscription_id,admin_user_id})
}

getUnAllottedLicensesList(){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/getUnAllottedLicensesList',{user_id})

}

checkIfCompanyAllotted(company_id){
  return this.httpClient.post<any>(this.api_url + '/checkIfCompanyAllotted',{company_id})

}

validateAdminUser( admin_user_id,product_id){
  // var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/validateAdminUser',{ admin_user_id,product_id })

}

updateAdminUserPassword(subscription_id){
  return this.httpClient.post<any>(this.api_url + '/updateAdminUserPassword',{ subscription_id })
}

postFile(fileToUpload) {
  var user_id =  localStorage.getItem('nu_c_user_id');
  var profile_image = fileToUpload;
  return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {profile_image,user_id});
  
}

gettimezones() {
  return this.httpClient.post<any>(this.api_url + '/getTimeZone', {});
}

updateStore(storeData){
  var user_id =  localStorage.getItem('nu_c_user_id');
  let StoreData = {
    "storeData":storeData,
    "user_id":user_id
  }

  return this.httpClient.post<any>(this.api_url + '/updateStore',{StoreData})

}

CreateCompanyStores(storeData,companyId){
  var user_id =  localStorage.getItem('nu_c_user_id');
  // let storesData  = JSON.parse(companyData);  
  let StoreData = {
    "storeData":storeData,
    "user_id":user_id
  }

  return this.httpClient.post<any>(this.api_url + '/CreateCompanyStores',{ StoreData,companyId})
}

getStateName(state_id){

  return this.httpClient.post<any>(this.api_url + '/getStateName',{ state_id})
}

getProductPackage(product_id) {
  return this.httpClient.post<any>(this.api_url + '/getProductPackage', { product_id });
}

getProductPackageById(package_id) {
  return this.httpClient.post<any>(this.api_url + '/getProductPackageById', { package_id });
}

getProductPackageAll(package_type) {
  return this.httpClient.post<any>(this.api_url + '/getProductPackageAll', {package_type});
}

changeSubscription(license_id,package_id,package_type,free_plan) {
  return this.httpClient.post<any>(this.api_url + '/changeSubscription', {license_id,package_id,package_type,free_plan});
}

checkFreeTrial(user_id) {
  return this.httpClient.post<any>(this.api_url + '/checkFreeTrial', {user_id});
}
getUserCards(){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/getUserCards',{user_id})
}

getUserCardsWorking(){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/getUserCardsWorking',{user_id})
}

getUserPlans(){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/getUserPlans',{user_id})
}

updateLicenseAdmin(license_id,admin_id){
  return this.httpClient.post<any>(this.api_url + '/updateLicenseAdmin', {license_id,admin_id });
}

updateLicenseCard(card_id,license_id){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/updateLicenseCard', {card_id,user_id,license_id });
}

addUserCard(card_id,stripe_token,licenseId,addcard = ''){
  var user_id =  localStorage.getItem('nu_c_user_id');
  return this.httpClient.post<any>(this.api_url + '/addUserCard',{user_id,card_id,stripe_token,licenseId,addcard})
}

checkAllottedStore(store_id,product_id){
  var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
  return this.httpClient.post<any>(this.api_url + '/checkAllottedStore',{user_id,store_id,product_id})
}

  downloadInvoice(billing_id){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/downloadInvoice',{user_id,billing_id})
  }

  purchaseCredit(card_id,amount){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/purchaseCredit', {card_id,amount,user_id });
  }
	
	updatetopup(card_id,amounttop1,amounttop2){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/updatetopup', {card_id,amounttop1,amounttop2,user_id });
  }

  loginwithToken(token) {
    return this.httpClient.post<any>(this.api_url + '/loginwithToken', {token });
  }

  stripe_key(){
    //return 'pk_test_3TLPNfRAH1xS1R8mZRmlZ9An00S1qrBW9R';
    return 'pk_live_LWzHgoJ0Ubvi9G8ijuzMXgGG00MPpclTID';
  }

  getAdminUserList(){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/getAdminUserList',{user_id})
  }  
  
  
  getSubAdminList(){
    var user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/getSubAdminList',{user_id})
  }

  updateAdminUser(user_id,email,first_name,last_name,password='',permissions=''){
    var admin_user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/updateCustomerInfo', {email,first_name,last_name,user_id,admin_user_id,password,permissions });
  }

  deleteUser(user_id){
    var admin_user_id =  JSON.parse(localStorage.getItem('nu_c_user_id'));
    return this.httpClient.post<any>(this.api_url + '/deleteUser', {user_id,admin_user_id });
  }
}



